// extracted by mini-css-extract-plugin
export var accordion = "_b1-0";
export var chevron = "_b1-3";
export var closed = "_b1-2";
export var content = "_b1-4";
export var open = "_b1-1";
export var rotate = "_b1-5";